namespace TabAurous.Sales {
    export namespace SalesQuotationService {
        export const baseUrl = 'Sales/Quotation';

        export declare function Create(request: Serenity.SaveRequest<SalesQuotationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesQuotationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesQuotationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SubmitQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ApproveQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesQuotationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Sales/Quotation/Create",
            Update = "Sales/Quotation/Update",
            Delete = "Sales/Quotation/Delete",
            Retrieve = "Sales/Quotation/Retrieve",
            List = "Sales/Quotation/List",
            SubmitQuotation = "Sales/Quotation/SubmitQuotation",
            ApproveQuotation = "Sales/Quotation/ApproveQuotation",
            PartyList = "Sales/Quotation/PartyList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'SubmitQuotation', 
            'ApproveQuotation', 
            'PartyList'
        ].forEach(x => {
            (<any>SalesQuotationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
